<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EiQOan/tc-custom/9781035815128.jpg?1705687958718" alt="This image is the cover for the book Emergence - Book One of the Alicorn Quest"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emergence - Book One of the Alicorn Quest
      </h1>
      <p class="bookDescription body article font2">
        <p>In a bygone age, India’s forests whispered tales of unicorns. The magic nestled within their spiralled horns was legendary, with villagers weaving tales of its mesmerizing properties. But these stories also painted targets on the creatures. Driven by greed, hunters came in droves, seeking the power in those horns. With every stolen horn, they boasted their conquests, leaving a trail of slain unicorns and bystanders in their wake. Darkness soon descended upon the forest, and the once-celebrated unicorns faded into myths. Yet hope endured through ancient prophecies predicting the unicorns’ return. Symbols of their resurgence – a golden seven-pointed star and a bangle adorned with horse and unicorn carvings – were foretold to re-emerge. And in November 1861, these artifacts surfaced from the ocean’s depths, heralding the start of The Alicorn Quest. This epic journey follows a young Indian adventurer’s quest to an unfamiliar Oregon, where destiny awaits in the form of a unique colt. As adversaries thwart his path, this colt, unaware of his future, grazes in Oregon’s</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William R Jenkins Jr
      </h2>
      
      <p class="authorDescription body article">William worked as an engineering designer in Pennsylvania, Florida, Minnesota and Oregon. In the spring of 2007, he retired intending to write a practical environmental engineering CAD drawing production guide. However, he chose to pursue his dream of writing fiction instead. For over twenty-years, William’s daughter has either leased or owned horses. And has competed in both dressage and western riding matches. She is also a riding instructor for young adults and kids. Her involvement with horses has provided him with an extensive background on their behaviour and nature. When not writing, William enjoys drawing, painting and photography.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?99dffa9c